import i18next from 'i18next';
import { LicenseDetailsDto, LicensePhaseDto, LicensePhaseViewModel } from '../../codegen/Swagger';
import { setDefaultInsteadOfNullByDataType } from '../../libs/form/initialValuesHelper';
import modifyDeep from '../../libs/modifyDeep';
import { LicensesMethods } from './hooks/useSecurityLicenses';
export const licenseOnRequestDataTransform = (data: LicenseDetailsDto) => {
    const normalizedData = setDefaultInsteadOfNullByDataType(data, 'string', '', ['name']);
    return {
        ...normalizedData,
        publicInvestigationApplicable: !data.publicInvestigationApplicable,
        ovcapplicable: !data.ovcapplicable,
        decisionApplicable: !data.decisionApplicable,

        submitApplicationSubmittedToNavigation:
            data.submitApplicationSubmittedToNavigation?.id == 0 ? null : data.submitApplicationSubmittedToNavigation,
        submitApplicationStatusStart:
            data.submitApplicationStatusStart?.id == 0 ? null : data.submitApplicationStatusStart,
        submitApplicationStatusEnd: data.submitApplicationStatusEnd?.id == 0 ? null : data.submitApplicationStatusEnd,

        publicInvestigationStatusStart:
            data.publicInvestigationStatusStart?.id == 0 ? null : data.publicInvestigationStatusStart,
        publicInvestigationStatusEnd:
            data.publicInvestigationStatusEnd?.id == 0 ? null : data.publicInvestigationStatusEnd,

        ovcstatus: data.ovcstatus?.id == 0 ? null : data.ovcstatus,

        decisionStatus: data.decisionStatus?.id == 0 ? null : data.decisionStatus,

        administrativeStatusStart: data.administrativeStatusStart?.id == 0 ? null : data.administrativeStatusStart,
        administrativeStatusEnd: data.administrativeStatusEnd?.id == 0 ? null : data.administrativeStatusEnd,
    } as LicenseDetailsDto;
};

export const licensePhaseOnRequestDataTransform = (data: LicensePhaseViewModel) => {
    if (data.licensePhases) {
        for (let i = 0; i < data.licensePhases.length; i++) {
            data.licensePhases[i].startStatus =
                data.licensePhases[i].startStatus?.id == 0 ? undefined : data.licensePhases[i].startStatus;
            data.licensePhases[i].endStatus =
                data.licensePhases[i].endStatus?.id == 0 ? undefined : data.licensePhases[i].endStatus;
        }
    }
    return data;
};

export const filterTooltip = (element: HTMLElement, showTooltipClass: string) => {
    if (element.classList.contains(showTooltipClass) || element.parentElement?.classList.contains(showTooltipClass)) {
        return true;
    }
    return false;
};

export enum MutationOperationType {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    APPROVE = 'APPROVE',
}

export enum LicenseWorkflowStatus {
    New = 1,
    Modified,
    Approved,
    Rejected,
}
export const getStatusTooltipText = (statusId: number) => {
    return i18next.t(LicenseWorkflowStatus[statusId].toString());
};
export const needDecision = (statusId: number) => {
    if (statusId <= LicenseWorkflowStatus.Modified) {
        return true;
    }
    return false;
};

export const isCreateType = (mutationOperationType: MutationOperationType) =>
    mutationOperationType === MutationOperationType.CREATE;

export const isUpdateType = (mutationOperationType: MutationOperationType) =>
    mutationOperationType === MutationOperationType.UPDATE;

export const isDeleteType = (mutationOperationType: MutationOperationType) =>
    mutationOperationType === MutationOperationType.DELETE;

export const isApproveType = (mutationOperationType: MutationOperationType) =>
    mutationOperationType === MutationOperationType.APPROVE;

export const trimStrings = (obj: any) => {
    // Object.keys(obj).forEach((key) => {
    //     if (typeof obj[key] === 'string') {
    //         obj[key] = obj[key].trim();
    //     }
    // });
    modifyDeep(obj, (key: any, value: any) => {
        if (typeof value === 'string') return value.trim();

        return value;
    });
};
export const getActionColWidth = (rights: any) => {
    const approveBtnWidth = 38;
    const deleteBtnWidth = 38;
    let baseWidth = 76;
    if (rights[LicensesMethods.Approve]) {
        baseWidth += approveBtnWidth;
    }
    if (rights[LicensesMethods.Delete]) {
        baseWidth += deleteBtnWidth;
    }
    return baseWidth;
};
